import React from "react";
import { RCCButton, RCCGrid,  RCCProgress, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import CardBadgesContent from "src/components/DashboardComponents/DefaultDashboardComponents/CardBadgesContent";
import CardContentSquares from "src/components/DashboardComponents/DefaultDashboardComponents/CardContentSquares";
import CardSquares from "src/components/DashboardComponents/DefaultDashboardComponents/CardSquares";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { IDashboardActionsData } from "../interface";

const DashboardCardsActions: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();

	const {data , loading} = useEffectFetchData<IDashboardActionsData[]> (
		"DashboardActions/List", 
		{ group: false }
	);

	const percent = (value: number, total: number) => total === 0 ? Number((0).toFixed(2)) : Number(((value / total) * 100).toFixed(2));

	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Andamento Ações por Situação")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to="/actions/panel">
					<RCCTooltip
						text={translate("Painel de ações")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="actions"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
				<Link to="/actions/matrix">
					<RCCTooltip
						text={translate("Matriz de ações")}
						color="grey"
					>
						<RCCButton 
							color="transparent"
							icon={{
								name: "table",
								color: "var(--app-icons-color)"
							}}
						/>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>

			
			<DefaultBody>
				{data && data[0] ? (
					<>
						<RCCGrid container item justifyContent="flex-end" alignItems="center">
							<CardBadgesContent>
								<span className="default-color-font">  {translate("Total")}  {data[0].total}</span>
								<span className="purple"> {translate("Não iniciadas")} {data[0].notStarted}</span>
							</CardBadgesContent>  
						</RCCGrid>
						<CardContentSquares>
							<CardSquares>
								<RCCProgress 
									layout="circle"
									value={percent(data[0].inProgress, data[0].total)}
									color="var(--blue)"
									width="70px"
								/>
								<span className="value" >{data[0].inProgress}</span>
								<span className="text"> {translate("Em andamento")} </span>
							</CardSquares>
							<CardSquares>
								<RCCProgress 
									layout="circle"
									value={percent(data[0].dueDateExpired, data[0].total)}
									color="var(--red)"
									width="70px"
								/>
								<span className="value" >{data[0].dueDateExpired}</span>
								<span className="text"> {translate("Atrasadas")} </span>
							</CardSquares>
							<CardSquares>
								<RCCProgress 
									layout="circle"
									value={percent(data[0].finished, data[0].total)}
									color="var(--green)"
									width="70px"
								/>
								<span className="value" >{data[0].finished}</span>
								<span className="text"> {translate("Concluídas")} </span>
							</CardSquares>
						</CardContentSquares>
					</>
				): null}
			</DefaultBody>
		
		
		</DefaultContainer>
	);};

export default DashboardCardsActions;
